import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

interface CountdownTimerProps {
  timeRemaining: number;
}

const CountdownTimer: React.FC<CountdownTimerProps> = ({ timeRemaining }) => {
  const [remaining, setRemaining] = useState(timeRemaining);

  useEffect(() => {
    const timer = setInterval(() => {
      setRemaining((prevRemaining) => Math.max(0, prevRemaining - 1));
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  }, [timeRemaining]);

  const formatTime = (seconds: number) => {
    const hours = Math.floor(seconds / 3600);
    const remainingMinutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${hours.toString().padStart(2, "0")}:${remainingMinutes
      .toString()
      .padStart(2, "0")}:${remainingSeconds.toString().padStart(2, "0")}`;
  };

  return <div className="text-4xl font-semibold">{formatTime(remaining)}</div>;
};

interface CountdownComponentProps {
  targetTime: number;
  label?: string;
}

const CircularCountdown: React.FC<CountdownComponentProps> = ({
  targetTime,
  label = "Until opens",
}) => {
  const { t } = useTranslation();

  // Вычисляем оставшееся время в секундах
  const timeRemaining = Math.max(0, (targetTime - Date.now()) / 1000);

  return (
    <div className="flex items-center">
      <div className="ml-4 pt-2 w-40">
        <p className="text-textsecondary pb-2">{t(label)}:</p>
        <CountdownTimer timeRemaining={timeRemaining} />
      </div>
    </div>
  );
};

export default CircularCountdown;